export const ar_routes = {
  home: "/ar",
  about: "/ar/about",
  faq: "/ar/faq",
  contact: "/ar/contact",
  taxiServiceMakkah: "/ar/taxi-service-makkah",
  taxiServiceMadinah: "/ar/taxi-service-madinah",
  jaddahAirportTaxiService: "/ar/jaddah-airport-taxi-service",
  hotelTransport: "/ar/hotel-transport",
  ziyaratTaxiService: "/ar/ziyarat-taxi-service",
  airportTransfers: "/ar/airport-transfers",
};

export const en_to_ar_path: Record<string, string> = {
  "/": ar_routes.home,
  "/about": ar_routes.about,
  "/faq": ar_routes.faq,
  "/contact": ar_routes.contact,
  "/taxi-service-makkah": ar_routes.taxiServiceMakkah,
  "/taxi-service-madinah": ar_routes.taxiServiceMadinah,
  "/jaddah-airport-taxi-service": ar_routes.jaddahAirportTaxiService,
  "/hotel-transport": ar_routes.hotelTransport,
  "/ziyarat-taxi-service": ar_routes.ziyaratTaxiService,
  "/airport-transfers": ar_routes.airportTransfers,
};

export const ar_to_en_path: Record<string, string> = Object.fromEntries(
  Object.entries(en_to_ar_path).map(([en, ar]) => [ar, en])
);
